<script>
export default {
  name: "InnerColorPicker",
  functional: true,
  render: function (h, { props, parent, children, listeners, data, ...args }) {
    const { name, value, isMonitor, showLabel } = props;
    
    const change = listeners.change;
    return (
      <div class={"inner_color_picker"}>
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        <el-color-picker onChange={change} color-format="rgb" class="pick_color" value={value} appendToBody={!Boolean(isMonitor)}>
        </el-color-picker>
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";
.inner_color_picker{
  display: flex;
  flex-direction: row;
  align-items: center
}
.pick_color{
  margin-top: 0px;
}
.pick_color ::v-deep .el-color-picker__trigger{
  padding: 0px ;
}
</style>
